export default __webpack_public_path__ + "static/media/Crystal 9781843626336.ec766a60.jpg";